import React from 'react';
import './GapStyle.css';

const Gap = () => <div className="gap"></div>;

export default Gap;